export default __webpack_public_path__ + "static/bncff-web-site-3-mobile-1d4596b02b889f862b414821c05865ce.jpg";